import React, { useMemo } from 'react'
import KanBoIcon from 'components/KanBoIcon'
import {
  ListItem
} from 'components/List'
import styled from 'styled-components'
import DocumentItem from 'routes/Board/DocumentList/DocumentItem'
import useGetData from 'hooks/useGetData'

const StyledDocumentItem = styled(DocumentItem)`
  margin: 0 -10px;
`

const StyledListItem = styled(ListItem)`
  margin: 0 -10px;
`

const SelectedDocumentFolder: React.FC<React.ComponentProps<typeof DocumentItem> & {
  documentSourceId: number;
  path?: string;
}> = ({
  documentSourceId,
  path,
  ...props
}) => {
  const isDocumentSource = useMemo(() => !path || path === '/', [path])

  const args = useMemo(() => {
    if (isDocumentSource) {
      return {
        id: documentSourceId
      }
    } else {
      return {
        items: [{
          sourceId: documentSourceId,
          url: path,
        }]
      }
    }
  }, [documentSourceId, path, isDocumentSource])
  const {
    data,
  }: {
    data: any
  } = useGetData(isDocumentSource ? 'DocumentsSourceDetailed' : 'Files', args)

  return data ? (        
    isDocumentSource ? (
      <StyledDocumentItem
        {...props}
        type='source'
        documentSourceId={documentSourceId}
        name={data.Name}
        fullUrl={data.FullUrl}
      />
    ) : (
      <StyledDocumentItem
        {...props}
        type='folder'
        documentSourceId={documentSourceId}
        url={data.Items?.[0]?.Url}
        name={data.Items?.[0]?.Name}
        subtitle={data.Items?.[0]?.FullUrl}
        noAccess={!data.Items?.[0]?.Exists || !data.Items?.[0]?.CanRead}
      />
    )
  ) : (
    <StyledListItem
      {...props}
      borderedIcon
      icon={<KanBoIcon spin name='kanbo-16-loading' />}
    />
  )
}

export default SelectedDocumentFolder
